<template>
    <div name="20250219" class="contents">
        <h1>개인정보 수집 및 이용 동의</h1>
<h2>[의료기관용] 개인정보 수집·이용 동의서</h2>

솔닥 주식회사는 진료(비대면/대면 진료) 서비스 제공을 위하여 아래와 같이 의료기관의 개인정보를 수집ᆞ이용하고자 합니다.<br>
내용을 자세히 읽으신 후 동의 여부를 결정하여 주세요.<br>

<table>
    <thead>
      <tr>
        <th>구분</th>
        <th>처리항목</th>
        <th>세부내용</th>
        <th>보유 및 이용 기간</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td rowspan="2">회원 가입 및 관리</td>
        <td>- 회원 가입 및 이용자 식별<br>- 가입의사 확인</td>
        <td>
          아이디, 비밀번호, 의료진 이름, 대표자 이메일, 계좌번호 및 통장 사본, 의료진 이름, 전문 분야, 진료과, 근무처 정보(병원/약국명, 주소, 연락처), 면허 번호, 면허증 사본, 학력, 경력, 진료과목, 진료가능과목, 요양기관번호, 사업자등록번호, 암호화된 동일인 식별정보(CI), 중복가입 확인정보(DI)
        </td>
        <td rowspan="4">서비스 회원 탈퇴 및 이용계약 종료 시<br>(단, 관련법령에 따라 별도 보관되는 정보는 예외)</td>
      </tr>
      <tr>
        <td>서비스 제공에 관한 계약 이행 및 요금 정산</td>
        <td>정산용 계좌번호, 통장 사본</td>
      </tr>
      <tr>
        <td rowspan="2">기타 서비스</td>
        <td>- 기타 문의<br>- 서비스 요청에 대한 응대 및 처리</td>
        <td>
          서비스 이용기록, 접속 기기 정보, 접속로그, 접속 IP 정보, 쿠키, 방문 일시, 불량 이용 기록, 광고식별자, 사용 이동통신사, 상담 내역
        </td>
      </tr>
      <tr>
        <td>- 솔닥 서비스 개발 및 맞춤 서비스 제공<br>- 새로운 서비스 안내<br>- 이벤트 등 광고성 정보 제공</td>
        <td>
          의료기관명, 의료기관 전화번호, 담당 의료인 이름, 휴대전화 번호, 이메일, 의료기관 홈페이지
        </td>
      </tr>
    </tbody>
  </table>
  <br>
※ 위의 개인정보 수집ᆞ이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우, 솔닥 진료(비대면/대면 진료) 서비스 이용에 제한을 받을 수 있습니다.


    </div>
</template>

<script>
export default {
    name: '20250219'
}
</script>

<style scoped>
    .contents {
        padding: 20px;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      text-align: left;
    }
    th, td {
      border: 1px solid #000;
      padding: 8px;
      vertical-align: top;
    }
    th {
      background-color: #f4f4f4;
      font-weight: bold;
      text-align: center;
    }
    td {
      background-color: #ffffff;
    }
</style>


// WEBPACK FOOTER //
// src/pages/partners/contents/use/medical/20250219.vue